import React from 'react';
import { useT } from '../../i18n';

// 子页占位 — 路由就位、UI 留空, 等后续填实
export default function StubPage({
  title, hint,
}: { title: string; hint?: string }) {
  const t = useT();
  return (
    <div style={{
      height: '100%', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 10,
      color: '#8598AD', fontSize: 13, padding: 30,
    }}>
      <div style={{ fontSize: 28, opacity: 0.4 }}>○</div>
      <div style={{ fontSize: 15, fontWeight: 600, color: '#4F6680' }}>{t(title)}</div>
      <div style={{ fontSize: 12, maxWidth: 420, textAlign: 'center', lineHeight: 1.6 }}>
        {t(hint || '本子页待实装。数据模型已就绪,后续迭代填充界面。')}
      </div>
    </div>
  );
}
